// Empty prefix is the default option.
// On the backend it's null, but on the frontend we operate with an empty string ''.
export const DEFAULT_INVOICE_PREFIX = ''
